var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgR5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 112,
    viewBox: "0 0 113 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666504,
    width: 112,
    height: 112,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5409 63C52.3623 62.3079 52.0015 61.6762 51.4961 61.1708C50.9907 60.6653 50.359 60.3046 49.6669 60.126L37.3969 56.962C37.1875 56.9026 37.0033 56.7765 36.8721 56.6029C36.7409 56.4293 36.6699 56.2176 36.6699 56C36.6699 55.7824 36.7409 55.5707 36.8721 55.3971C37.0033 55.2235 37.1875 55.0974 37.3969 55.038L49.6669 51.872C50.3588 51.6936 50.9903 51.3332 51.4957 50.8281C52.0011 50.323 52.362 49.6918 52.5409 49L55.7049 36.73C55.7637 36.5198 55.8896 36.3347 56.0635 36.2028C56.2374 36.0709 56.4496 35.9995 56.6679 35.9995C56.8861 35.9995 57.0984 36.0709 57.2722 36.2028C57.4461 36.3347 57.5721 36.5198 57.6309 36.73L60.7929 49C60.9714 49.6922 61.3322 50.3238 61.8376 50.8292C62.3431 51.3347 62.9747 51.6955 63.6669 51.874L75.9369 55.036C76.1479 55.0942 76.3339 55.22 76.4665 55.3942C76.5992 55.5683 76.671 55.7811 76.671 56C76.671 56.2189 76.5992 56.4317 76.4665 56.6059C76.3339 56.78 76.1479 56.9058 75.9369 56.964L63.6669 60.126C62.9747 60.3046 62.3431 60.6653 61.8376 61.1708C61.3322 61.6762 60.9714 62.3079 60.7929 63L57.6289 75.27C57.5701 75.4802 57.4441 75.6653 57.2702 75.7972C57.0964 75.9291 56.8841 76.0005 56.6659 76.0005C56.4476 76.0005 56.2354 75.9291 56.0615 75.7972C55.8876 75.6653 55.7617 75.4802 55.7029 75.27L52.5409 63Z",
    stroke: "#0034A3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.667 38V46",
    stroke: "#0034A3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6665 42H68.6665",
    stroke: "#0034A3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.666 66V70",
    stroke: "#0034A3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6665 68H38.6665",
    stroke: "#0034A3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgR5);
export default __webpack_public_path__ + "static/media/r5.d635527799ce348cf38e43eb61699b75.svg";
export { ForwardRef as ReactComponent };